/**
 * @flow
 * @relayHash b5d1bfdd856c0b98fca1294446458d19
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AuthenticationContainer_user$ref = any;
export type AuthenticationViewQueryVariables = {|
  userId: string
|};
export type AuthenticationViewQueryResponse = {|
  +user: ?{|
    +$fragmentRefs: AuthenticationContainer_user$ref
  |}
|};
export type AuthenticationViewQuery = {|
  variables: AuthenticationViewQueryVariables,
  response: AuthenticationViewQueryResponse,
|};
*/


/*
query AuthenticationViewQuery(
  $userId: String!
) {
  user(userId: $userId) {
    ...AuthenticationContainer_user
    id
  }
}

fragment AuthenticationContainer_user on User {
  id
  email
  username
  ...AssignExperimentGroupsContainer_user
}

fragment AssignExperimentGroupsContainer_user on User {
  id
  joined
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "AuthenticationViewQuery",
  "id": null,
  "text": "query AuthenticationViewQuery(\n  $userId: String!\n) {\n  user(userId: $userId) {\n    ...AuthenticationContainer_user\n    id\n  }\n}\n\nfragment AuthenticationContainer_user on User {\n  id\n  email\n  username\n  ...AssignExperimentGroupsContainer_user\n}\n\nfragment AssignExperimentGroupsContainer_user on User {\n  id\n  joined\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AuthenticationViewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "AuthenticationContainer_user",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AuthenticationViewQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "username",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "joined",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8eb1f773649b756f546ceeeb231c6536';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Authentication/__generated__/AuthenticationViewQuery.graphql.js